import styled from 'styled-components';

import { typography } from './mixins';

const Paragraph = styled.p`
  ${typography};
`;

export default Paragraph;
